import { base64decode } from 'nodejs-base64';
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import Navbar from "react-bootstrap/NavBar";
import Nav from "react-bootstrap/Nav";
import NavItem from "react-bootstrap/NavItem";
import { Container } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCircle } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'

import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { v1 as uuidv1 } from 'uuid'


import Routes from "./Routes";
import { AppContext } from "./libs/contextLib";
import { onError } from "./libs/errorLib";
import { useAuth } from "./libs/authLib";

import './App.css';

function App() {
  const history = useHistory();
  const [isAuthenticating, setIsAuthenticating, isAuthenticated, userHasAuthenticated, getSession, setSession, signup, login, logout] = useAuth(null, true, false);
  const [session, setSess] = useState(null)

  useEffect(() => {
    onLoad();
  }, []);
  
  async function onLoad() {
    try {
      if (!Cookie.get('sessionID')) {
        Cookie.set('sessionID', uuidv1()) 
      }

      setIsAuthenticating(true);
      //await Auth.currentSession();
      const s = getSession()
      setSess(s)
    }
    catch(e) {
      if (e !== 'No current user') {
        onError(e);
      }
    }
  
    setIsAuthenticating(false);
  }

  async function handleLogout() {    
    setIsAuthenticating(true);

    try {
      await logout()
      history.push("/");
    } catch (e) {
      onError(e)
      console.log(e)
    } finally {
      setIsAuthenticating(false);
    }
  }

  return (    
    !isAuthenticating && <>
    <Container fluid style={{background: 'white'}}>
      <Container fluid>
      <Switch>                
        <Route>
          <Navbar collapseOnSelect expand="lg"  >
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Brand>
                <Link to="/" className="logo">&nbsp;</Link>
              </Navbar.Brand>              
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                  <LinkContainer to="/">
                    <Nav.Link href="/">Shows</Nav.Link>
                  </LinkContainer>              
                </Nav>
                <Nav>
                  
                  {isAuthenticated
                    ? <>
                        <LinkContainer to="/user">
                          <Nav.Link >{session ? session.user.fullname : "User"} <FontAwesomeIcon icon={faUserCircle} /></Nav.Link>
                        </LinkContainer>                      
                        <Nav.Link onClick={handleLogout} className="highlight1"> Salir</Nav.Link>
                      </>
                    : <>                        
                        <LinkContainer to="/login">
                          <Nav.Link className="highlight1">Ingresa</Nav.Link>
                        </LinkContainer>
                      </>
                  }
                </Nav>
              </Navbar.Collapse>
          </Navbar>
        </Route>
      </Switch>
    </Container>
    </Container>
    <AppContext.Provider value={{ isAuthenticated, setIsAuthenticating, userHasAuthenticated, getSession, setSession, login, signup, logout }}>
      <Routes />
    </AppContext.Provider>
    <Container>


    </Container>
    
    
    </>
  );
}
/*
<Container>
      <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated, getSession, setSession, login, signup }}>
        <Routes />
      </AppContext.Provider>
    </Container> 
*/
export default App;
